import { Badge, Button, Loader, Table, Text } from '@mantine/core'
import { modals } from '@mantine/modals'
import { IconRestore, IconTrash } from '@tabler/icons-react'
import { useTrashList, useTrashMutations } from '@/pages/Boards/hooks'

export const TrashTab = () => {
  const { data, isLoading } = useTrashList(true)
  const { restoreBoard, purgeBoard } = useTrashMutations()
  const boards = data?.boards ?? []

  const confirmPurge = (id: string, name: string) =>
    modals.openConfirmModal({
      title: 'Delete permanently',
      children: (
        <Text size="sm">
          Permanently delete “{name}” and all of its tasks? This cannot be undone.
        </Text>
      ),
      labels: { confirm: 'Delete permanently', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: () => void purgeBoard.mutateAsync({ id }).catch(() => undefined),
    })

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loader size="sm" />
      </div>
    )
  }

  if (boards.length === 0) {
    return (
      <div className="flex flex-col items-center gap-2 rounded-md border border-[#EEEEEE] bg-white py-16">
        <p className="text-sm text-gray-500">Trash is empty</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <Text size="sm" c="dimmed">
        Deleted boards stay in Trash until a super admin permanently deletes them. Restore or delete
        them now.
      </Text>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Board</Table.Th>
            <Table.Th>Deleted</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {boards.map((b) => (
            <Table.Tr key={b.id}>
              <Table.Td>{b.name}</Table.Td>
              <Table.Td>
                <Badge variant="light" color="gray">
                  {new Date(b.trashedAt).toLocaleDateString()}
                </Badge>
              </Table.Td>
              <Table.Td>
                <div className="flex justify-end gap-2">
                  <Button
                    size="xs"
                    variant="default"
                    leftSection={<IconRestore size={14} />}
                    loading={restoreBoard.isPending}
                    onClick={() =>
                      void restoreBoard.mutateAsync({ id: b.id }).catch(() => undefined)
                    }
                  >
                    Restore
                  </Button>
                  <Button
                    size="xs"
                    color="red"
                    variant="light"
                    leftSection={<IconTrash size={14} />}
                    onClick={() => confirmPurge(b.id, b.name)}
                  >
                    Delete permanently
                  </Button>
                </div>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  )
}
